import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const HeartOutline = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.8065 6.20635C4.70663 5.30649 5.92731 4.80097 7.2001 4.80097C8.47288 4.80097 9.69356 5.30649 10.5937 6.20635L12.0001 7.61155L13.4065 6.20635C13.8493 5.7479 14.3789 5.38223 14.9646 5.13066C15.5502 4.8791 16.18 4.74669 16.8174 4.74115C17.4547 4.73561 18.0868 4.85706 18.6767 5.09841C19.2666 5.33975 19.8025 5.69617 20.2532 6.14685C20.7039 6.59754 21.0603 7.13347 21.3016 7.72337C21.543 8.31327 21.6644 8.94533 21.6589 9.58268C21.6534 10.22 21.5209 10.8499 21.2694 11.4355C21.0178 12.0211 20.6521 12.5508 20.1937 12.9935L12.0001 21.1883L3.8065 12.9935C2.90664 12.0934 2.40112 10.8727 2.40112 9.59995C2.40112 8.32716 2.90664 7.10648 3.8065 6.20635V6.20635Z"
          stroke={color}
          strokeOpacity="0.8"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default HeartOutline
